export enum SectionId {
  a1ScreeningNegativoMinimo = 'a1ScreeningNegativoMinimo',
  a2Onboarding = 'a2Onboarding',
  a3AnalisiDelleGaranzieDueDiligence = 'a3AnalisiDelleGaranzieDueDiligence',
  identificazioneDelSettore = 'identificazioneDelSettore',
  b1TipologiaDiProcedura = 'b1TipologiaDiProcedura',
  c1CalcoloKriDovePrevisto = 'c1CalcoloKriDovePrevisto',
  c2VerificaRegolaritaDebitiTributariEPrevidenziali = 'c2VerificaRegolaritaDebitiTributariEPrevidenziali',
  c3ValutazioneScostamentoRispettoAlPiano = 'c3ValutazioneScostamentoRispettoAlPiano',
  c4PresenzaPareriEsterni = 'c4PresenzaPareriEsterni',
  c5AnalisiDelBusiness = 'c5AnalisiDelBusiness',
  regolaritaDeiPagamenti = 'regolaritaDeiPagamenti',
  d1RankingGiuridico = 'd1RankingGiuridico',
  d2RankingContrattuale = 'd2RankingContrattuale',
  d3FinalitaDelFinanziamento = 'd3FinalitaDelFinanziamento',
  d4RecoveryAnalysis = 'd4RecoveryAnalysis',
  d5VelocitaESicurezzaDiRecuperoDellEscussioneDellaGaranzia = 'd5VelocitaESicurezzaDiRecuperoDellEscussioneDellaGaranzia',
  e1CriteriDiErogazioneEsg = 'e1CriteriDiErogazioneEsg',
  e2DueDiligenceEsg = 'e2DueDiligenceEsg',
  e3RatingEsg = 'e3RatingEsg',
}
